import { literal, number, object, preprocess } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

export const PointSpendEarningMechanismSchema = object({
  pointCost: number({ required_error: IS_REQUIRED }),
});

export const RewardFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.Reward),
  pointSpend: preprocess((value) => value ?? {}, PointSpendEarningMechanismSchema),
});
